// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xnS85","active":"styles_active__P19+e","activeCenter":"styles_activeCenter__HJKfb","inactive":"styles_inactive__GohWF"};